"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartyName = void 0;
var PartyName;
(function (PartyName) {
    PartyName["MARS"] = "Mars First";
    PartyName["SCIENTISTS"] = "Scientists";
    PartyName["UNITY"] = "Unity";
    PartyName["KELVINISTS"] = "Kelvinists";
    PartyName["REDS"] = "Reds";
    PartyName["GREENS"] = "Greens";
})(PartyName = exports.PartyName || (exports.PartyName = {}));
